import Link from 'next/link'
import React from 'react'

import { cn } from '@/utilities/ui'
import type { CMSLinkType } from '@/types/CMSLink'

const appearanceClass: Record<string, string> = {
  default: 'cta-primary',
  outline: 'cta-secondary',
}

export const CMSLink: React.FC<CMSLinkType> = (props) => {
  const {
    type,
    appearance = 'inline',
    children,
    className,
    label,
    newTab,
    reference,
    url,
    onClick,
  } = props

  const href = getHref()

  if (!href) return null

  const isAnchor = href.startsWith('#') || href.startsWith('/#')
  const newTabProps = newTab ? { rel: 'noopener noreferrer', target: '_blank' } : {}
  const resolvedClassName = cn(appearance && appearanceClass[appearance], className)

  if (isAnchor) {
    return (
      <a href={href} className={resolvedClassName} onClick={onClick}>
        {label}
        {children}
      </a>
    )
  }

  return (
    <Link className={resolvedClassName} href={href} onClick={onClick} {...newTabProps}>
      {label}
      {children}
      {newTab && <span className="sr-only"> (nouvelle fenêtre)</span>}
    </Link>
  )

  function getHref() {
    if (type === 'reference' && reference?.value && typeof reference.value === 'object') {
      if (reference.relationTo === 'anchors') {
        const anchorDoc = reference.value
        const anchorSlug = anchorDoc.anchor.replace(/^#/, '')
        const anchorPage =
          anchorDoc.page && typeof anchorDoc.page === 'object' ? anchorDoc.page : null

        if (anchorPage?.slug) {
          const pagePath = anchorPage.slug === 'home' ? '' : `/${anchorPage.slug}`
          return `${pagePath}/#${anchorSlug}`
        }

        return `#${anchorSlug}`
      }

      if (reference.relationTo === 'pages') {
        const slug = reference.value.slug
        if (slug !== null && slug !== undefined) {
          return slug === 'home' ? '/' : `/${slug}`
        }
      }

      return null
    }

    if (type === 'custom' && url) {
      return url
    }

    return null
  }
}
